const gradeArr = [{id: 1, name: '一年级'}, {id: 2, name: '二年级'}, {id: 3, name: '三年级'}, {id: 4, name: '四年级'}, {id: 5, name: '五年级'}, {id: 6, name: '六年级'}, {id: 7, name: '初一年级'}, {id: 8, name: '初二年级'}, {id: 9, name: '初三年级'}, {id: 10, name: '高一年级'}, {id: 11, name: '高二年级'}, {id: 12, name: '高三年级'}, {id: 13, name: '大学一年级'}, {id: 14, name: '大学二年级'}, {id: 15, name: '大学三年级'}, {id: 16, name: '大学四年级'}]
const gradeZZArr = [{id: 1, name: '一年级'}, {id: 2, name: '二年级'}, {id: 3, name: '三年级'}, {id: 4, name: '四年级'}, {id: 5, name: '五年级'}, {id: 6, name: '六年级'}, {id: 7, name: '初一年级'}, {id: 8, name: '初二年级'}, {id: 9, name: '初三年级'}, {id: 10, name: '中职一年级'}, {id: 11, name: '中职二年级'}, {id: 12, name: '中职三年级'}, {id: 13, name: '中职四年级'}, {id: 14, name: '中职五年级'}, {id: 15, name: '大学三年级'}, {id: 16, name: '大学四年级'}]

export default (info, SCHOOL_TYPE) => {
  if (info) {
    console.log(SCHOOL_TYPE)
    if (SCHOOL_TYPE === 2) {
      let list = gradeZZArr.filter(item => item.id === info)
      return list[0] ? list[0].name : '未知'
    } else {
      let list = gradeArr.filter(item => item.id === info)
      return list[0] ? list[0].name : '未知'
    }
  }
}
